export interface BookingPractitioner {
  id: string;
  name: string;
  role: string;
  details: string;
  image: string;
}

export const practitioners: BookingPractitioner[] = [
  {
    id: "data_c_10",
    name: 'Dr. med. dent. Thomas Müller',
    role: 'Zahnarzt',
    details: 'Postgraduate in Kronen-Brückenprothetik, Teilprothetik und Materialkunde',
    image: '/images/offices/Thomas/Thomas.png',
  },
  {
    id: "data_c_11",
    name: 'Dr. med. dent. Benjamin Weidmann',
    role: 'Zahnarzt',
    details: 'MAS Parodontologie',
    image: '/images/offices/Thomas/Beni.png',
  },
  {
    id: "data_c_12",
    name: 'Dr. med. dent. Nathalie Heeb-Rüedi',
    role: 'Zahnärztin',
    details: 'WBA Allgemeine Zahnmedizin, Curriculum Implantologie i.A.',
    image: '/images/offices/Thomas/Nathalie.png',
  },
  {
    id: "data_c_20",
    name: 'Melanie Weber',
    role: 'Dentalhygienikerin',
    details: '',
    image: '/images/offices/Thomas/Melanie-Weber.jpg',
  },
  {
    id: "data_c_21",
    name: 'Lara Keller',
    role: 'Prophylaxeassistentin',
    details: '',
    image: '/images/offices/Thomas/Lara-Keller.jpg',
  },
];

export const isDentalCleaning = (procedureId: string, procedureName?: string) =>
  procedureId === 'proc813' || (typeof procedureName === 'string' && procedureName.startsWith('dental-cleaning-'));

export const isRoleAllowed = (practitioner: BookingPractitioner, dentalCleaning: boolean) =>
  ['Zahnarzt', 'Zahnärztin'].includes(practitioner.role) ||
  (dentalCleaning && ['Dentalhygienikerin', 'Dentalhygieniker', 'Prophylaxeassistentin', 'Prophylaxeassistent'].includes(practitioner.role));

export const clearPractitionerSelection = () => {
  localStorage.removeItem('selectedPractitionerId');
  localStorage.removeItem('selectedPractitionerMode');
  localStorage.removeItem('pendingAppointmentFull');
};
